type ShouldRedirectToProductsPageArgs = {
  isSessionActive: boolean;
  isAuthenticated: boolean;
  isDiningOptionSelected: boolean;
  hasPreCheckoutTextInputs: boolean;
};

/**
 * Returns true if the user should be redirected to the products page.
 *
 * Redirect cases:
 * - Redirect once the user has: selected a dining option and authenticated
 * - Redirect once the user has: selected a dining option and is not authenticated
 * - Redirect once there are no dining options and the user has: tapped "Tap to begin" button
 * - Redirect once there are no dining options and the user has: authenticated
 *
 * @param args `isSessionActive`, `isAuthenticated`, `isDiningOptionSelected`, `hasPreCheckoutTextInputs`.
 * @returns true if the user should be redirected to the products page.
 */
export function shouldRedirectToProductsPage({
  isSessionActive,
  isAuthenticated,
  isDiningOptionSelected,
  hasPreCheckoutTextInputs
}: ShouldRedirectToProductsPageArgs): boolean {
  if (!isSessionActive) {
    return false;
  }

  // Redirect once the user has: selected a dining option and authenticated
  if (hasPreCheckoutTextInputs && isAuthenticated && isDiningOptionSelected) {
    return true;
  }

  // Redirect once the user has: selected a dining option and is not authenticated
  if (hasPreCheckoutTextInputs && !isAuthenticated && isDiningOptionSelected) {
    return true;
  }

  // Redirect once there are no dining options and the user has: tapped "Tap to begin" button<
  if (
    !hasPreCheckoutTextInputs &&
    !isAuthenticated &&
    !isDiningOptionSelected
  ) {
    return true;
  }

  // Redirect once there are no dining options and the user has: authenticated
  if (!hasPreCheckoutTextInputs && isAuthenticated && !isDiningOptionSelected) {
    return true;
  }

  return false;
}
